import { PyramidGameObj } from "@/app/lib/game-state/game-manager";
import WordModule from "@/app/lib/game-state/word-module";
import UI from "@/app/lib/ui/ui"

// currently built for Pyramid's reveal function only
export function revealAnimation({
    pyramid,
    ui,
    trueVictory,
    intervalDelay = 0,
    animations
}: {
    pyramid: PyramidGameObj,
    ui: UI
    trueVictory: boolean,
    intervalDelay: number,
    animations: Array<() => void>
}) {
    // convert to ms
    intervalDelay *= 1000;
    const state = pyramid.state;
    // get a copy of used solutions
    const usedSolutions: string[] = [...state.usedSolutions];

    for (const wordModule of state.words) {
        // default option is to reveal the seedword
        let revealWord: string = wordModule.puzzleWord;
        // check if the seedword has been used elsewhere
        if (usedSolutions.includes(wordModule.puzzleWord.toLowerCase())) {
            // search for an alternate solution
            let alternateSolution: string = '';
            for (const candidateWord of state.solutions) {
                if (
                    // can't be already used
                    !usedSolutions.includes(candidateWord)
                    && wordModule.validate(candidateWord, state.ingredients)
                ) {
                    alternateSolution = candidateWord;
                    break;
                }
            }
            if (alternateSolution !== '') {
                revealWord = alternateSolution;
                usedSolutions.push(alternateSolution);
            }
        }
        // the timeout delays the reveal and animation in a cascade
        setTimeout(() => {
            pyramid.update(state => {
                state.words[wordModule.index].reveal(revealWord);
            });
            animations[wordModule.index]?.();
        }, intervalDelay * wordModule.index)
    }

    // the final update is delayed until last
    // length will equal final index + 1
    setTimeout(() => {
        pyramid.update(state => {
            state.markCompleted(trueVictory);
            // for recording purposes, update the used solutions
            state.usedSolutions = usedSolutions;
        });
        if (!trueVictory) {
            if (ui.userHistory.streakCount > 0) {
                ui.resetStreak('sad');
            } else {
                ui.resetStreak(null);
            }
        }
    }, intervalDelay * state.words.length);
}